const FilterData = (inputValue,data) =>
  data.filter(i =>
    i.label.toLowerCase().includes(inputValue.toLowerCase())
  );


export default FilterData;



// WEBPACK FOOTER //
// ./src/utils/strings/FilterData.js